import { useState } from "react";
import { QualifyingQuestion } from "@/types/jobAdsTypes";
import { trpcClient } from "@/trpc/client";

export const useQualifyingQuestions = () => {
  const [questions, setQuestions] = useState<QualifyingQuestion[]>([]);
  const [isGenerating, setIsGenerating] = useState(false);
  // Vault documents the questions were shaped by, for the review note in step 4.
  const [sourceDocuments, setSourceDocuments] = useState<string[]>([]);

  const generateQuestions = async (
    description: string,
    role: string,
    businessUid: string,
  ): Promise<{ questions: QualifyingQuestion[]; isFallback: boolean }> => {
    setIsGenerating(true);
    try {
      const result =
        await trpcClient.jobAdAi.generateQualifyingQuestions.mutate({
          businessUid,
          description,
          roleTitle: role,
        });

      setQuestions(result.questions);
      setSourceDocuments(result.sourceDocuments ?? []);
      return result;
    } catch (error) {
      console.error("Error generating qualifying questions:", error);
      setSourceDocuments([]);
      const fallback: QualifyingQuestion[] = [
        {
          question: `Har du erfarenhet från liknande roller som ${role}?`,
          positiveResponse: "Ja",
          negativeResponse: "Nej",
          onPositiveResponse: "Perfekt, då har vi mycket att prata om.",
          onNegativeResponse: "Inget problem – berätta gärna mer i chatten.",
          isRequired: true,
          order: 1,
        },
        {
          question: "Kan du arbeta heltid på plats i Stockholm?",
          positiveResponse: "Ja",
          negativeResponse: "Nej",
          onPositiveResponse: "Bra, då ses vi där.",
          onNegativeResponse: "Vi kan kolla vad som går att lösa.",
          isRequired: true,
          order: 2,
        },
        {
          question: "Kan du börja inom 1–2 månader?",
          positiveResponse: "Ja",
          negativeResponse: "Nej",
          onPositiveResponse: "Toppen, då kan vi ta nästa steg.",
          onNegativeResponse: "Vi hör av oss och ser vad som passar.",
          isRequired: true,
          order: 3,
        },
      ];
      setQuestions(fallback);
      return { questions: fallback, isFallback: true };
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    questions,
    setQuestions,
    isGenerating,
    generateQuestions,
    sourceDocuments,
  };
};

export default useQualifyingQuestions;
